module.exports = __webpack_public_path__ + "img/2000-mobile.7777f676.jpg";